// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {Href} from 'docs/markdoc/attribute-types';

export const CodeSampleCard: MarkdocTagRegistration = {
  tag: 'code-sample-card',
  component: 'CodeSampleCard',
  attributes: {
    title: {
      type: String,
      required: true,
      localizable: true,
      description: 'Title of the card',
    },
    href: {
      type: Href,
      required: true,
      description: 'URL that clicking the card will take you to',
    },
    tags: {
      type: Array,
      required: true,
      description: 'Tags to display next to the GitHub icon in the card footer',
    },
  },
};
